import type { ZudokuConfig } from "zudoku";

// Public Volt Platform API docs (docs.getvolt.tech). Renders the audience-
// filtered public OpenAPI spec the API serves at /openapi.public.json. The
// spec's own `servers` list (production + development) drives the environment
// switcher in the "try it" playground — no per-site config needed for that.
//
// The spec ORIGIN is build-time configurable so a prod build can pull from the
// prod API while dev pulls from dev. Defaults to dev.
const API_ORIGIN =
  process.env.DOCS_API_ORIGIN ?? "https://api.platform-dev.getvolt.tech";

const config: ZudokuConfig = {
  site: {
    title: "Volt Platform",
  },
  metadata: {
    title: "Volt Platform API",
    description:
      "Documentation for the Volt Platform API — the customer and partner surface.",
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: ["/introduction", "/mcp"],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  apis: {
    type: "url",
    input: `${API_ORIGIN}/openapi.public.json`,
    path: "/api",
  },
};

export default config;
